export class LandingRedirectSignal extends Error {
  readonly destination: string;
  readonly status: number;
  constructor(destination: string, status = 307) {
    super(`Redirect to ${destination}`);
    this.destination = destination;
    this.status = status;
  }
}

export class LandingNotFoundSignal extends Error {
  readonly status = 404;
  constructor() {
    super("Not found");
  }
}

export function redirect(destination: string): never {
  if (typeof window !== "undefined") window.location.assign(destination);
  throw new LandingRedirectSignal(destination);
}

export function permanentRedirect(destination: string): never {
  if (typeof window !== "undefined") window.location.replace(destination);
  throw new LandingRedirectSignal(destination, 308);
}

export function notFound(): never {
  throw new LandingNotFoundSignal();
}

export function usePathname(): string {
  return typeof window === "undefined" ? "/" : window.location.pathname;
}

export function useSearchParams(): URLSearchParams {
  return new URLSearchParams(
    typeof window === "undefined" ? "" : window.location.search,
  );
}

export function useParams<T extends Record<string, string>>() {
  return {} as T;
}

export function useRouter() {
  return {
    push: (href: string) => window.location.assign(href),
    replace: (href: string) => window.location.replace(href),
    back: () => window.history.back(),
    forward: () => window.history.forward(),
    refresh: () => window.location.reload(),
    prefetch: async (_href: string) => undefined,
  };
}
